import { render, staticRenderFns } from "./SearchNavItemSelect.vue?vue&type=template&id=5fe67570&scoped=true"
import script from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
export * from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemSelect.vue?vue&type=style&index=0&id=5fe67570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe67570",
  null
  
)

export default component.exports